module.exports = __webpack_public_path__ + "media/images/alf_logo_w-1bc9c14cd9e7a4aeb1fb8c5ced0bc002.png";